import type { DeepString } from "@/lib/i18n";

export const pl = {
  defaultTitle: "Wybrane realizacje",
  seeRealization: "Zobacz realizację",
  seeAll: "Wszystkie realizacje",
  prev: "Poprzednia",
  next: "Następna",
  goToSlide: "Przejdź do referencji",
} as const;

export type WRealizationsTestimonialsTranslations = DeepString<typeof pl>;
